import { render, staticRenderFns } from "./pre_table_nokey_20210512.vue?vue&type=template&id=4c87bdc3&scoped=true"
import script from "./pre_table_nokey_20210512.vue?vue&type=script&lang=js"
export * from "./pre_table_nokey_20210512.vue?vue&type=script&lang=js"
import style0 from "./pre_table_nokey_20210512.vue?vue&type=style&index=0&id=4c87bdc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87bdc3",
  null
  
)

export default component.exports